const Awards = [
  {
    text: "ICHack 2022 Runner Up for Best Entertainment Hack",
    tip: "Build-A-Story"
  },
  {
    text: "ICHack 2020 Winner for Best Smart Home / Internet of Things Hack",
    tip: "Porcupine Smart Mirror"
  },
  {
    text: "ICHack 2019 Runner Up for Best Web App",
    tip: "Singalong"
  },
  {
    text: "2nd in Imperial Java Pawn Race",
    tip: "Pawn only chess engine contest"
  },
  {
    text: "Blundell's Ondaatje Hall Medal",
    tip: "Development of School Diversity and Culture"
  },
  {
    text: "Blundell's Computer Science Prize",
    tip: "Subject Prize"
  },
  {
    text: "Blundell's Heads Honors",
    tip: "Outstanding work in Mathematics"
  },
  {
    text: "UKSMC Best In Year and British Maths Olympiad Participant",
    tip: "1000 highest performers in the UK selected"
  }
]

export default Awards;